<ng-container *ngIf="isOpen()">
  <div
    class="quiz-modal"
    role="dialog"
    aria-modal="true"
    aria-labelledby="quiz-modal-title"
  >
    <div class="quiz-modal__backdrop"></div>

    <div class="quiz-modal__sheet">
      <header class="quiz-modal__header">
        <button
          type="button"
          class="quiz-modal__close"
          aria-label="Cerrar"
          (click)="onClose()"
        >
          <img
            src="assets/icons/ic_close_circle.svg"
            width="24"
            height="24"
            alt=""
            aria-hidden="true"
          />
        </button>
        <h2 id="quiz-modal-title" class="quiz-modal__title t-20-700-primary">
          Cuestionario
        </h2>
      </header>

      <div class="quiz-modal__body">
        <div *ngIf="questions().length" class="quiz-modal__list">
          <app-question-item
            *ngFor="let question of questions(); let i = index; trackBy: trackByQuestionId"
            [question]="question"
            [selectedOptionId]="selectedOptionFor(question.questionId)"
            [expanded]="isExpanded(question.questionId)"
            [index]="i + 1"
            (toggle)="onToggle(question.questionId)"
            (selectionChange)="onSelection(question.questionId, $event)"
          ></app-question-item>
        </div>
      </div>

      <footer class="quiz-modal__footer">
        <p-button
          label="Finalizar"
          type="button"
          [disabled]="!canSubmit()"
          (onClick)="onSubmit()"
          styleClass="quiz-modal__submit"
        ></p-button>
      </footer>
    </div>
  </div>
</ng-container>
